import { useEffect, useCallback, useState } from 'react';

import { useCustomComponentStateContext } from './useCustomComponentState';
import { isGrowthBookFeatureOnQuery } from '../graphql';
import useApolloClient from '../lib/apolloClient';

const useMLProductRecs = (feature: string): boolean | undefined => {
  const { state } = useCustomComponentStateContext();
  const [flag, setFlag] = useState<boolean>();
  const apolloClient = useApolloClient();
  const {
    retailerMoniker,
    localeCountry,
    localeLanguage,
    trackingStatus,
    trackingNumbers,
    orderNumbers,
  } = state?.pageContext || {};
  const [orderNumber] = orderNumbers ?? [];
  const [trackingNumber] = trackingNumbers ?? [];

  const isMLProductRecs =
    state?.queryData?.retailerSettings?.productRecommendations?.type ===
    'ML_ENGINE';

  const fetchMLProductRecsFlag = useCallback(async () => {
    const attributes = {
      track_localeCountry: localeCountry,
      track_localeLanguage: localeLanguage,
      track_orderNumber: orderNumber,
      track_retailerMoniker: retailerMoniker,
      track_shipmentStatus: trackingStatus,
      track_trackingNumber: trackingNumber,
    };

    try {
      const response =
        apolloClient &&
        (await apolloClient.query({
          query: isGrowthBookFeatureOnQuery,
          variables: {
            project: 'TRACK',
            feature,
            attributes,
          },
        }));

      const enabled =
        (response?.data as { isGrowthBookFeatureOn: boolean } | undefined)
          ?.isGrowthBookFeatureOn || false;

      setFlag(enabled);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error fetching growthbook config', e);
    }
  }, [
    apolloClient,
    localeCountry,
    localeLanguage,
    orderNumber,
    retailerMoniker,
    trackingStatus,
    trackingNumber,
    feature,
  ]);

  useEffect(() => {
    if (!isMLProductRecs) return;

    fetchMLProductRecsFlag().catch((e) => console.error(e));
  }, [isMLProductRecs, fetchMLProductRecsFlag]);

  return flag;
};

export default useMLProductRecs;
